import { createAction, props } from '@ngrx/store';

import { Order, OrderStatusStep, OrderTracking } from '@api/order/order.models';

export const ReturnFeedbackAnalyticsActions = {
    SET_STEP: '[Order status] SET_STEP',
    SET_ORDER_STATUS: '[Order status] SET_ORDER_STATUS',
    SET_ORDER_NUMBER: '[Order status] SET_ORDER_NUMBER',
    SET_ORDER_SUCCESS: '[Order status] SET_ORDER_SUCCESS',
    SET_ORDER_ERROR: '[Order status] SET_ORDER_ERROR',
    SET_ORDER_ERROR_TRACKING: '[Order status] SET_ORDER_ERROR_TRACKING',
    SET_ORDER_GUEST: '[Order status] SET_ORDER_GUEST',
    SET_ORDER_GUEST_SUCCESS: '[Order status] SET_ORDER_GUEST_SUCCESS',
    SET_ORDER_GUEST_ERROR: '[Order status] SET_ORDER_GUEST_ERROR',
};

export const SetStepOrderStatus = createAction(
    ReturnFeedbackAnalyticsActions.SET_STEP,
    props<{ step: OrderStatusStep }>()
);

export const SetOrderNumber = createAction(
    ReturnFeedbackAnalyticsActions.SET_ORDER_NUMBER,
    props<{ orderNumber: string }>()
);

export const SetOrderStatus = createAction(
    ReturnFeedbackAnalyticsActions.SET_ORDER_STATUS,
    props<{ orderStatus: Order | OrderTracking }>()
);

export const SetOrderSuccess = createAction(
    ReturnFeedbackAnalyticsActions.SET_ORDER_SUCCESS,
    props<{ orderStatus: Order }>()
);

export const SetOrderError = createAction(
    ReturnFeedbackAnalyticsActions.SET_ORDER_ERROR,
    props<{ error: string; orderId: string }>()
);

export const SetOrderErrorTracking = createAction(
    ReturnFeedbackAnalyticsActions.SET_ORDER_ERROR_TRACKING,
    props<{ error: string; orderId: string }>()
);

export const SetOrderGuest = createAction(
    ReturnFeedbackAnalyticsActions.SET_ORDER_GUEST,
    props<{ orderId: number; guestId: string }>()
);

export const SetOrderGuestSuccess = createAction(
    ReturnFeedbackAnalyticsActions.SET_ORDER_GUEST_SUCCESS,
    props<{ orderStatus: Order }>()
);

export const SetOrderGuestError = createAction(
    ReturnFeedbackAnalyticsActions.SET_ORDER_GUEST_ERROR,
    props<{ error: string; orderId: string }>()
);
